var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ImportTotal"}},[_c('div',{staticClass:"num"},[_c('span',{},[_vm._v(_vm._s(_vm.formatNumber(_vm.data.importValue)))]),_c('span',{staticClass:"text-lg"},[_vm._v("万元")])]),_c('div',{staticClass:"title"},[_vm._v("进口总额")]),_c('img',{staticClass:"m-auto",attrs:{"src":require("@/assets/img/Group219.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }